const pacificDateElement = document.getElementById('date');

if (pacificDateElement) {
  const dateParts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const dateValues = Object.fromEntries(dateParts.map(({ type, value }) => [type, value]));

  pacificDateElement.textContent = `${dateValues.year}-${dateValues.month}-${dateValues.day}`;
}
